"use client";

import { useEffect } from "react";

import { useThirdPartiesStore } from "@/ui-state";

const telOrMailLinkRegexp = /^(tel|mailto):/gm;
const absoluteUrlRegexp = /^http(s)?:\/{2}(www.)?[\w-]+\.[\w]+/gim;
const allowedDomainsRegexp =
  /(localhost|(znanierussia|znan|roznanie|znanierussia\.accreditation)\.ru|t\.me|vk\.com|government\.ru|russia\.ru|\.gov\.ru|sovetnational\.ru|domnarodov\.ru|tavrida\.art|pochta\.ru|rguk\.ru|morethantrip\.ru|gastromaprussia\.ru|eksmo\.ru|tricolor\.ru|max\.ru)/gim;

const isOurResource = (href: string) => {
  allowedDomainsRegexp.lastIndex = 0;
  return allowedDomainsRegexp.test(href);
};

export const ThirdPartiesListener = () => {
  const { closeConfirmModal, showConfirmModal } = useThirdPartiesStore();

  useEffect(() => {
    const handleLinkClick = (event: Event) => {
      event.preventDefault();

      const target = event.currentTarget;

      if (!(target instanceof HTMLAnchorElement)) {
        return;
      }

      const href = target.getAttribute("href");

      showConfirmModal({
        onSuccess: () => {
          if (href) {
            window.open(href, "_blank");
          }

          closeConfirmModal();
        },
      });
    };

    const allLinks = Array.from(
      document.body.querySelectorAll<HTMLAnchorElement>("a[href]")
    );
    const externalLinks = allLinks.filter((element) => {
      telOrMailLinkRegexp.lastIndex = 0;
      absoluteUrlRegexp.lastIndex = 0;

      const href = element.href;
      const isMailOrPhone = telOrMailLinkRegexp.test(href);
      const isAbsoluteUrl = absoluteUrlRegexp.test(href);

      return isAbsoluteUrl && !isMailOrPhone && !isOurResource(href);
    });

    for (const link of externalLinks) {
      link.addEventListener("click", handleLinkClick);
    }

    return () => {
      for (const link of externalLinks) {
        link.removeEventListener("click", handleLinkClick);
      }
    };
  }, [closeConfirmModal, showConfirmModal]);

  return null;
};
